import EventBus from 'CORE/bus'
export const SHOW_PROMPT = '/prompt/show'
export const CONFIRM_PROMPT = '/prompt/confirm'
export const CANCEL_PROMPT = '/prompt/cancel'

export default {
    install(Vue, options) {
        Vue.prototype.$prompt = question => new Promise((resolve, reject) => {
            EventBus.$emit(SHOW_PROMPT, {
                question,
            })
            EventBus.$on(CONFIRM_PROMPT, resolve)
            EventBus.$on(CANCEL_PROMPT, reject)
        })
    },
}
